import { SelectField, SelectFieldProps } from '@ff-it/form';
import { useOOHCategoryFormatOptions } from './useOOHCategoryFormatOptions';
import { TitleContainer } from 'components/TitleContainer';
import { CategoryFormatOption } from './types';

export const formatOptionLabel = (v: CategoryFormatOption) => (
  <TitleContainer title={v.label} subtitle={v.description} />
);

export function OOHCategoryFormatField(
  props: Omit<
    SelectFieldProps<CategoryFormatOption, boolean>,
    'options' | 'loadOptions' | 'getOptionLabel' | 'getOptionValue' | 'simple'
  >,
) {
  const options = useOOHCategoryFormatOptions();

  return <SelectField options={options} formatOptionLabel={formatOptionLabel} {...props} simple />;
}
